import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import * as types from '../../actions/actionTypes';
import { getActiveSewpat, getNavigationSewpat } from '../../reducers/sewpats';
import CollapsableContainer from '../common/CollapsableContainer';
import Text from '../common/Text';
import Translatable from '../common/Translatable';
import Bottom from '../home/LandingPageBottom';
import LinearProgress from '../LinearProgress';
import CenteredPatternButton from './CenteredPatternButton';
import FabricRecommendation from './FabricRecommendation';
import HowTos from './HowTos';
import MaterialList from './MaterialList';
import Description from './SewpatDescription';
import FiguriCarousel from './SewpatFigurineCarousel';
import Heading from './SewpatHeading';
import Parts from './SewpatPartsImage';
import SewpatCarousel from './SewpatPictures';
import SizeHelp from './SewpatSizeHelp';
import SewpatSizesLevel from './SewpatSizesLevel';

const SingleSewpatView = ({ sewpat, path, dispatch }) => {
    const handleClick = () => {
        dispatch({
            type: types.SEWPAT_SELECTED,
            sewpatId: sewpat.id,
        });
        dispatch({
            type: types.NAVIGATED_TO_SEWPAT_PATTERN_GALLERY,
            payload: {
                sewpatId: sewpat.id,
                slug: 'pattern',
            },
        });
    };

    if (!sewpat || !sewpat.title) {
        return <LinearProgress />;
    }

    return (

        <div itemScope itemType='http://schema.org/Product'>
            <meta itemProp='brand' content='www.schnoffle.love' />
            <meta itemProp='url' content={`https://www.schnoffle.de${path}`} />
            <Helmet>
                <meta property='og:type' content='product' />
                <meta
                    property='og:title'
                    content={`${sewpat.title} - umfärbbares Schnittmuster-Motiv designt von schnittmuster-berlin.de | www.schnoffle.de`}
                />
                <meta property='og:brand' content='www.schnoffle.de' />
                <meta
                    property='og:description'
                    content={`${sewpat.title} designt von schnittmuster-berlin.de. ${sewpat.summary.content} Individuell einfärbbar in Deinen Wunschfarben. #schnittmuster #schnittmusterberlin #stofflove #stoffliebe #schnoffle`}
                />
                <meta
                    property='og:url'
                    content={`https://www.schnoffle.de${path}`}
                />
                <meta property='product:price:amount' content='49.95' />
                <meta property='product:price:currency' content='EUR' />
                <meta property='og:availability' content='instock' />
                <meta
                    property='og:image'
                    content={null}
                />
                <meta
                    property='og:image:alt'
                    content={sewpat.title}
                />
                <meta property='og:image:type' content='image/jpeg' />
            </Helmet>
            <Text>
                <Heading
                    title={sewpat.title}
                    designer={sewpat.designer.name}
                    handleClick={handleClick}
                />
            </Text>
            <FiguriCarousel handleClick={handleClick} />
            <Text.Divider />
            <Text>
                <Description sewpat={sewpat} />
                <SewpatSizesLevel sewpat={sewpat} />
            </Text>
            <Text.Divider />
            <SewpatCarousel sewpat={sewpat} />
            <Text.Divider />
            <Text>
                <FabricRecommendation sewpat={sewpat} />
                <Text.Divider />
                <CenteredPatternButton handleClick={handleClick} />
                <Text.Divider margin='1em 0 1em' />
            </Text>
            <CollapsableContainer
                heading={<Translatable
                    message='SEWPAT_MATERIAL_LIST_LABEL'
                />}
            >
                <MaterialList sewpat={sewpat} />
            </CollapsableContainer>
            <CollapsableContainer
                heading={<Translatable message='SEWPAT_DRAWING_PARTS' />}
            >
                <Parts sewpat={sewpat} />
            </CollapsableContainer>
            <SizeHelp />
            <Text>
                <Text.Divider />
                <HowTos sewpat={sewpat} />
                <Text.Divider />
            </Text>
            <CenteredPatternButton handleClick={handleClick} />
            <Text.Divider margin='1em 0 1em' />
            <Bottom />
        </div>
    );
};

const mapStateToProps = state => {
    const sewpat = getNavigationSewpat(state);
    return {
        sewpat,
        path: state.location.pathname,
    };
};

export default connect(mapStateToProps)(SingleSewpatView);



// WEBPACK FOOTER //
// ./src/components/sewpat/SingleSewpatView.js